var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Add, Cancel, Delete, Edit, LockReset, Save } from "@mui/icons-material";
import { Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Box, } from "@mui/material";
import React, { useState } from "react";
import Dropdown from "./dropdowns/Dropdown";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import 'dayjs/locale/en-au';
const CrudTable = ({ data, columns, addOnlyFields, onAdd, onEdit, onDelete, onResetPassword, initialItem, readonly, showSearch, showAddNew, showDelete, showResetPassword, crudMode, extraSearchFields, }) => {
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [newItem, setNewItem] = useState(initialItem);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const [searchQuery, setSearchQuery] = useState("");
    const [disbableDropdown, setDisableDropdown] = useState(true);
    const [addValidationErrors, setAddValidationErrors] = useState({});
    const [addApiError, setAddApiError] = useState(null);
    const [addSubmitting, setAddSubmitting] = useState(false);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleAdd = () => __awaiter(void 0, void 0, void 0, function* () {
        // Validate required fields
        const errors = {};
        [...columns, ...(addOnlyFields !== null && addOnlyFields !== void 0 ? addOnlyFields : [])].forEach((col) => {
            if (col.required) {
                const val = newItem[col.field];
                const isEmpty = val === null ||
                    val === undefined ||
                    val === "" ||
                    val === "00000000-0000-0000-0000-000000000000";
                if (isEmpty) {
                    errors[col.field] = `${col.headerName} is required`;
                }
            }
        });
        if (Object.keys(errors).length > 0) {
            setAddValidationErrors(errors);
            return;
        }
        setAddValidationErrors({});
        setAddApiError(null);
        setAddSubmitting(true);
        try {
            const result = yield onAdd(newItem);
            if (result) {
                // onAdd returned an error string — stay in modal
                setAddApiError(result);
            }
            else {
                setNewItem(initialItem);
                setOpenAddModal(false);
            }
        }
        finally {
            setAddSubmitting(false);
        }
    });
    const handleEdit = (item) => {
        onEdit(item);
        setCurrentItem(null);
    };
    const handleDelete = () => {
        if (currentItem) {
            onDelete(currentItem);
            setCurrentItem(null);
            setOpenDeleteDialog(false);
        }
    };
    const handleCancelEdit = () => {
        setDisableDropdown(true);
        setCurrentItem(null);
    };
    const confirmSave = () => {
        if (currentItem) {
            onEdit(currentItem);
            setCurrentItem(null);
            setOpenSaveDialog(false);
        }
    };
    const handleSort = (field) => {
        const isAsc = sortField === field && sortOrder === "asc";
        setSortOrder(isAsc ? "desc" : "asc");
        setSortField(field);
    };
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };
    const handleCheckboxChange = (event, field) => {
        if (currentItem) {
            console.log("Checked value is:", event.target.checked);
            const updatedRowCurrentItem = Object.assign(Object.assign({}, currentItem), { [field]: event.target.checked });
            setCurrentItem(updatedRowCurrentItem);
        }
    };
    const handleDropdownChange = (field, value) => {
        if (currentItem) {
            console.log("Dropdown value is:", value);
            const updatedRowCurrentItem = Object.assign(Object.assign({}, currentItem), { [field]: value !== null && value !== void 0 ? value : "" });
            console.log("Updated row is:", updatedRowCurrentItem);
            setCurrentItem(updatedRowCurrentItem);
        }
    };
    //==========================================================================================
    //            Cell Rendering, Determines how things are displayed, if read only
    //              and what control type should be rendered
    //==========================================================================================
    const renderCellContent = (item, column) => {
        //create a dropdown using the optionalColumnData [name, value] using mui Select
        const isCurrentRow = currentItem && item && currentItem.id === item.id;
        if (column.type === "boolean") {
            // currently selected for editing
            let isChecked = item[column.field];
            if (currentItem && item && currentItem.id === item.id) {
                isChecked = currentItem
                    ? currentItem[column.field]
                    : false;
            }
            return (React.createElement(Checkbox, { checked: Boolean(isChecked), disabled: !isCurrentRow || column.columnReadOnly, onChange: (event) => handleCheckboxChange(event, column.field) }));
        }
        // dropdowns
        if (column.type === "dropdown" &&
            column.optionalColumnData &&
            column.optionalColumnData.length > 0) {
            return (React.createElement(Dropdown, { items: column.optionalColumnData, displayName: "name", displayValue: "value", label: column.headerName, displayLabel: false, disabled: isCurrentRow ? disbableDropdown : true, value: isCurrentRow
                    ? currentItem[column.field]
                    : item[column.field], onChange: (changedValue) => handleDropdownChange(column.field, changedValue) }));
        }
        if (column.type === "date") {
            const dateValue = (isCurrentRow ? currentItem[column.field] : item[column.field]);
            const value = dayjs(dateValue);
            return React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: "en-au" },
                React.createElement(DatePicker, { value: value, onChange: (newValue) => {
                        if (currentItem) {
                            const updatedRowCurrentItem = Object.assign(Object.assign({}, currentItem), { [column.field]: newValue === null || newValue === void 0 ? void 0 : newValue.toDate() });
                            console.log("Updated row is:", updatedRowCurrentItem);
                            setCurrentItem(updatedRowCurrentItem);
                        }
                    }, disabled: !isCurrentRow || column.columnReadOnly, slotProps: {
                        textField: {
                            size: "small",
                        },
                    } }));
        }
        if (currentItem && item && currentItem.id === item.id) {
            if (column.columnReadOnly === true) {
                const res = item ? item[column.field] : "";
                if (res == null)
                    return "";
                return String(res);
            }
            return (React.createElement(TextField, { value: currentItem[column.field], disabled: column.columnReadOnly, onChange: (e) => setCurrentItem(Object.assign(Object.assign({}, currentItem), { [column.field]: e.target.value })), sx: {
                    margin: "0px !important",
                    padding: "0px !important",
                    fontSize: 11,
                    width: "100%",
                }, margin: "dense", size: "small" }));
        }
        else {
            const res = item ? item[column.field] : "";
            if (res == null)
                return "";
            return String(res);
        }
    };
    const filteredData = React.useMemo(() => {
        if (!searchQuery)
            return data;
        //check if is array if not return empty array
        if (!Array.isArray(data))
            return [];
        const q = searchQuery.toLowerCase();
        return data.filter((item) => {
            const matchesColumn = columns.some((column) => String(item[column.field]).toLowerCase().includes(q));
            if (matchesColumn)
                return true;
            if (extraSearchFields) {
                return extraSearchFields.some((field) => { var _a; return String((_a = item[field]) !== null && _a !== void 0 ? _a : "").toLowerCase().includes(q); });
            }
            return false;
        });
    }, [data, searchQuery, columns, extraSearchFields]);
    const sortedData = React.useMemo(() => {
        if (!sortField)
            return filteredData !== null && filteredData !== void 0 ? filteredData : [];
        return [...filteredData].sort((a, b) => {
            if (a[sortField] < b[sortField])
                return sortOrder === "asc" ? -1 : 1;
            if (a[sortField] > b[sortField])
                return sortOrder === "asc" ? 1 : -1;
            return 0;
        });
    }, [filteredData, sortField, sortOrder]);
    const paginatedData = React.useMemo(() => {
        //check if is array if not return empty array
        if (!Array.isArray(sortedData))
            return [];
        return sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [sortedData, page, rowsPerPage]);
    return (React.createElement(Container, { maxWidth: false, sx: {
            width: "100%",
            margin: "15px 0px 0px 0px !important",
            padding: "0px !important",
        } },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, md: 2, xs: 12, sx: { display: showAddNew ? "block" : "none" } }, !readonly && (React.createElement(Button, { variant: "contained", color: "primary", startIcon: React.createElement(Add, null), onClick: () => setOpenAddModal(true), sx: { margin: "0px 0px 15px 0px" } }, "Add New"))),
            React.createElement(Grid, { item: true, xs: readonly ? 12 : 10, sx: { display: showSearch ? "block" : "none" } },
                React.createElement(TextField, { placeholder: "Search...", value: searchQuery, onChange: handleSearchChange, fullWidth: true, sx: { margin: "0px 0px 15px 0px" } })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(TableContainer, { component: Paper },
                    React.createElement(Table, null,
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, { sx: { "& th": { padding: "4px 8px" } } },
                                columns.map((column, index) => (React.createElement(TableCell, { key: `${index}-${String(column.field)}`, onClick: () => handleSort(column.field), sx: {
                                        cursor: "pointer",
                                        width: column.width ? column.width : "auto",
                                    } },
                                    column.headerName,
                                    sortField === column.field
                                        ? sortOrder === "asc"
                                            ? " ▲"
                                            : " ▼"
                                        : ""))),
                                React.createElement(TableCell, { sx: {
                                    // textAlign: "right",
                                    // display: "flex",
                                    // justifyContent: "flex-end",
                                    }, align: "right" }, "Actions"))),
                        React.createElement(TableBody, null,
                            paginatedData.map((item, rowIndex) => (React.createElement(TableRow, { key: `${item.id}-rowIndex-${rowIndex}`, sx: { "& td": { padding: "4px 8px" } } },
                                columns.map((column) => (React.createElement(TableCell, { key: `${item.id}-${String(column.field)}`, sx: { width: column.width ? column.width : "auto" } }, renderCellContent(item, column)))),
                                React.createElement(TableCell, { sx: {
                                    // textAlign: "right",
                                    // display: "flex",
                                    // justifyContent: "flex-end",
                                    }, align: "right" }, currentItem && currentItem.id === item.id ? (React.createElement(React.Fragment, null,
                                    React.createElement(IconButton, { color: "primary", onClick: () => handleEdit(currentItem) },
                                        React.createElement(Save, null)),
                                    React.createElement(IconButton, { color: "primary", onClick: handleCancelEdit },
                                        React.createElement(Cancel, null)))) : (React.createElement(React.Fragment, null,
                                    React.createElement(IconButton, { color: "primary", onClick: () => {
                                            console.log("Update clicked");
                                            setDisableDropdown(false);
                                            setCurrentItem(item);
                                        } },
                                        React.createElement(Edit, null)),
                                    React.createElement(IconButton, { color: "primary", onClick: () => {
                                            setCurrentItem(item);
                                            setOpenDeleteDialog(true);
                                        }, sx: {
                                            display: showDelete ? "block" : "none",
                                        } },
                                        React.createElement(Delete, null)),
                                    React.createElement(IconButton, { color: "primary", onClick: () => onResetPassword === null || onResetPassword === void 0 ? void 0 : onResetPassword(item), sx: {
                                            display: showResetPassword ? "block" : "none",
                                        } },
                                        React.createElement(LockReset, null)))))))),
                            sortedData.length === 0 && (React.createElement(React.Fragment, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, { colSpan: columns.length + 1, align: "center" }, "No data available"))))))),
                React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25, 50, 100], component: "div", count: sortedData.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }))),
        React.createElement(Dialog, { open: openAddModal, onClose: () => { setOpenAddModal(false); setAddValidationErrors({}); setAddApiError(null); }, maxWidth: "sm", fullWidth: true },
            React.createElement(DialogTitle, null, "Add New Item"),
            React.createElement(DialogContent, null,
                addApiError && (React.createElement(Box, { sx: { mb: 2 } },
                    React.createElement(Box, { sx: { color: 'error.main', bgcolor: 'error.light', px: 2, py: 1, borderRadius: 1, fontSize: 14 } }, addApiError))),
                columns.map((column) => {
                    var _a;
                    const fieldError = addValidationErrors[column.field];
                    // Handle boolean type - render checkbox
                    if (column.type === "boolean") {
                        return (React.createElement(FormControlLabel, { key: String(column.field), control: React.createElement(Checkbox, { checked: newItem[column.field], disabled: addSubmitting, onChange: (e) => setNewItem(Object.assign(Object.assign({}, newItem), { [column.field]: e.target.checked })) }), label: column.headerName + (column.required ? " *" : "") }));
                    }
                    // Handle dropdown type
                    else if (column.type === "dropdown" && column.optionalColumnData) {
                        return (React.createElement(Box, { key: String(column.field), sx: { marginY: 1 } },
                            React.createElement(Dropdown, { items: column.optionalColumnData, displayName: "name", displayValue: "value", label: column.headerName + (column.required ? " *" : ""), value: newItem[column.field], disabled: false, onChange: (value) => {
                                    setNewItem(Object.assign(Object.assign({}, newItem), { [column.field]: value }));
                                    if (value)
                                        setAddValidationErrors((prev) => { const e = Object.assign({}, prev); delete e[column.field]; return e; });
                                } }),
                            fieldError && React.createElement(Box, { sx: { color: 'error.main', fontSize: 12, mt: 0.5 } }, fieldError)));
                    }
                    // Handle date type - render DatePicker
                    else if (column.type === "date") {
                        return (React.createElement(Box, { key: String(column.field), sx: { marginY: 1 } },
                            React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: "en-au" },
                                React.createElement(DatePicker, { label: column.headerName + (column.required ? " *" : ""), value: newItem[column.field] ? dayjs(newItem[column.field]) : null, onChange: (newValue) => {
                                        setNewItem(Object.assign(Object.assign({}, newItem), { [column.field]: newValue ? newValue.toDate() : null }));
                                        if (newValue)
                                            setAddValidationErrors((prev) => { const e = Object.assign({}, prev); delete e[column.field]; return e; });
                                    }, slotProps: {
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            margin: "dense",
                                            error: !!fieldError,
                                            helperText: fieldError,
                                        },
                                    } }))));
                    }
                    // Default - render text field (password type renders masked)
                    else {
                        return (React.createElement(TextField, { key: String(column.field), margin: "dense", size: "small", type: column.type === "password" ? "password" : "text", label: column.headerName + (column.required ? " *" : ""), fullWidth: true, value: (_a = newItem[column.field]) !== null && _a !== void 0 ? _a : "", error: !!fieldError, helperText: fieldError, onChange: (e) => {
                                setNewItem(Object.assign(Object.assign({}, newItem), { [column.field]: e.target.value }));
                                if (e.target.value)
                                    setAddValidationErrors((prev) => { const e2 = Object.assign({}, prev); delete e2[column.field]; return e2; });
                            } }));
                    }
                }),
                addOnlyFields && addOnlyFields.map((column) => {
                    var _a;
                    const fieldError = addValidationErrors[column.field];
                    return (React.createElement(TextField, { key: String(column.field), margin: "dense", size: "small", type: column.type === "password" ? "password" : "text", label: column.headerName + (column.required ? " *" : ""), fullWidth: true, value: (_a = newItem[column.field]) !== null && _a !== void 0 ? _a : "", error: !!fieldError, helperText: fieldError, onChange: (e) => {
                            setNewItem(Object.assign(Object.assign({}, newItem), { [column.field]: e.target.value }));
                            if (e.target.value)
                                setAddValidationErrors((prev) => { const e2 = Object.assign({}, prev); delete e2[column.field]; return e2; });
                        } }));
                })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => { setOpenAddModal(false); setAddValidationErrors({}); setAddApiError(null); }, color: "primary" }, "Cancel"),
                React.createElement(Button, { onClick: handleAdd, color: "primary", variant: "contained", disabled: addSubmitting }, addSubmitting ? "Saving..." : "Add"))),
        React.createElement(Dialog, { open: openDeleteDialog, onClose: () => setOpenDeleteDialog(false) },
            React.createElement(DialogTitle, null, "Delete Item"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, "Are you sure you want to delete this item?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setOpenDeleteDialog(false), color: "primary" }, "Cancel"),
                React.createElement(Button, { onClick: handleDelete, color: "primary" }, "Delete"))),
        React.createElement(Dialog, { open: openSaveDialog, onClose: () => setOpenSaveDialog(false) },
            React.createElement(DialogTitle, null, "Save Changes"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, "Are you sure you want to save the changes?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setOpenSaveDialog(false), color: "primary" }, "Cancel"),
                React.createElement(Button, { onClick: confirmSave, color: "primary" }, "Save")))));
};
export default CrudTable;
